var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("Valid reels")]),_c('reel-selector',{attrs:{"disabled":_vm.disabled,"config":_vm.config},model:{value:(_vm.model.rules.reels),callback:function ($$v) {_vm.$set(_vm.model.rules, "reels", $$v)},expression:"model.rules.reels"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }